import { useCallback } from 'react'
import ApiService from 'services/ApiService'

const InteractorVisitHistorySearch = () => {
  const visitHistorySearch = useCallback((body, callback, loading) => {
    const payload = {
      ...body,
    }
    ApiService.jsonRequest('/customer/visit-history/search', payload, (response) => {
      loading(false)
      if (response.code === 7200) {
        callback(response.data)
      } else {
        callback(null)
      }
    })
  }, [])
  return { visitHistorySearch }
}

export default InteractorVisitHistorySearch
